<template>
    <div class="top-header">
        <div class="top-arrow" @click="goback" v-if="path !== ''">
            <md-icon name="arrow-left" size="md"></md-icon>
        </div>
        <div class="top-tx">{{ title }}</div>
        <div class="top-right">
            <slot name="right"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'topback',
    props: {
        title: {
            type: String,
            default: ""
        },
        path: {
            type: String,
            default: ""
        }
    },
    methods: {
        goback() {
            if(this.path === "back") {
                this.$router.back()
            } else if(this.path !== "") {
                this.$router.push(this.path)
            } else {
                return
            }
        }
    }
}

</script>
<style scoped>
.top-header {
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 998;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    font-size: 0.5rem;
    font-weight: bold;
    height: 1rem;
    background-color: #fff;
}
.top-arrow {
    position: absolute;
    left: 0.10rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.top-tx {

}
.top-right {
    position: absolute;
    right: 0.17rem;
}
</style>
  

  


// WEBPACK FOOTER //
// src/components/topback.vue